import { ref, onMounted, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useMenusList(){

    const toast = useToast()

    const refMenuListTable = ref(null)
    const refMenuCategoryListTable = ref(null)

    const tableColumns = [
        {key:'menu_title', label:'Menu' , sortable:true},
        // {key:'price', sortable:true},
        {key:'menu_content', sortable:true},
        {key:'menu_category_id', label:'Category',formatter:title,sortable:true},
        {key:'actions'}
    ]

    const categoryTableColumns = [
        {key:'label', label:'name'},
        {key:'actions'}
    ]
    const perPage = ref(10)
    const totalMenus = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const categoryOptions = ref([])
    const selectedCategory = ref(null)


    const dataMeta = computed(() => {
        const localItemsCount = refMenuListTable.value ? refMenuListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1: 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalMenus.value,
        }
    })

    const showMessage = (title,text,icon, variant) =>{
        toast({
            component: ToastificationContent,
            props: {
              title,
              text,
              icon,
              variant
            },
        })
    }

    const refetchData = () =>{
        refMenuListTable.value.refresh()
    }

    const getMenuImage = (image) =>  process.env.VUE_APP_IMAGE_URL+image

    watch([currentPage, perPage, searchQuery, selectedCategory], () => {
        refetchData()
    })

    const fetchMenus = (ctx, callback) => {

        store.dispatch('bar-menu/fetchMenus', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            category_id: selectedCategory.value?.value,
        })
        .then(response => {
            //console.log(response.data)
            const { menus, total} = response.data
            callback(menus)
            totalMenus.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                  title: 'Error fetching menus list',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
            })
        })
    }

    const fetchMenuCategories = (ctx, callback) => {
        store.dispatch('bar-menu/fetchMenuCategories')
        .then(response => {
             const categories = [];
             const {menu_categories} = response.data
             menu_categories.forEach(category => categories.push({label:category.name, value:category.id}));
             //console.log(categories)
             categoryOptions.value = categories
             console.log('categoryOptions.value', categoryOptions.value)
             //callback(categories)
             //return categories
        })
        .catch(error => {
            toast({
                component: ToastificationContent,
                props: {
                  title: error,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
            })
        })
    }
    onMounted(() => {
        fetchMenuCategories()
    })


    return {
        fetchMenus,
        fetchMenuCategories,
        tableColumns,
        categoryTableColumns,
        perPage,
        currentPage,
        totalMenus,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refMenuListTable,
        refMenuCategoryListTable,
        getMenuImage,
        showMessage,
        categoryOptions,
        selectedCategory,

        //Extra Filters
    }

}